import React, {useRef, useState} from 'react'
import {images} from '../../constants'
import {AppWrap, MotionWrap} from '../../wrapper'
import './Footer.scss'
import {TypeAnimation} from "react-type-animation";
import {sendForm} from "@emailjs/browser";

const Footer = () => {

    const [isFormSubmitted, setIsFormSubmitted] = useState(false)
    const [loading, setLoading] = useState(false)

    const form = useRef();
    const sendEmail = (e) => {

        e.preventDefault();
        setLoading(true);

        sendForm('service_t1x2usi', 'template_rxrvp67', form.current, 'LCmkHbXRWtN9aQhPC')
            .then(() => {
                setLoading(false)
                setIsFormSubmitted(true);
            }, (err) => {
                console.log(err)
            })
    }

    return (
        <>
            {!isFormSubmitted &&
                <TypeAnimation
                    sequence={[
                        'Contactez moi pour obtenir plus d\'Informations',
                        1200,
                        'Contactez moi pour obtenir plus de détails',
                        1200,
                        'Ou discuter de votre projet :)',
                        1200
                    ]}
                    speed={50}
                    repeat={Infinity}
                    className='head-text app__footer-anim'
                    omitDeletionAnimation
                />
            }
            <div className='app__footer-cards'>
                <div className='app__footer-card'>
                    <img src={images.email} alt='email'/>
                    <a href='mailto:mailhebiauannelise@gmail.com' className='p-text'>mailhebiauannelise@gmail.com</a>
                </div>
                <div className='app__footer-card'>
                    <img src={images.mobile} alt='mobile'/>
                    <a href='tel:+33659027342' className='p-text'>+33 6 59 02 73 42</a>
                </div>
                <div className='app__footer-card'>
                    <img src={images.instagram} alt='instagram'/>
                    <a href='https://instagram.com/al_communitymanager?igshid=OGQ5ZDc2ODk2ZA==' target='_blank'
                       className='p-text' rel="noreferrer">al_communitymanager</a>
                </div>
            </div>

            {!isFormSubmitted ?
                <form ref={form} onSubmit={sendEmail} className='app__footer-form app__flex'>
                    <div>
                        <label className='p-text'>Votre nom</label>
                        <input className='p-text' type='text' placeholder='Votre nom' name='name'/>
                    </div>
                    <div>
                        <label className='p-text'>Votre email</label>
                        <input className='p-text' type='email' placeholder='Votre email' name='email'/>
                    </div>
                    <div>
                        <label className='p-text'>Votre message</label>
                        <textarea className='p-text'
                                  placeholder='Votre Message :)'
                                  name='message'
                        />
                    </div>
                    <button type='submit' className='p-text'>{loading ? 'Message envoyé !' : 'Envoyer'}</button>
                </form>

                : <div>
                    <h3 className='head-text'>Merci de m'avoir contactée ! Je reviens vers vous au plus vite !</h3>
                </div>
            }
            <div className='copyright'>
                <p className='p-text'>©2023 Damien</p>
                <p className='p-text'>All rights reserved</p>
            </div>
        </>
    )
}

export default AppWrap(
    MotionWrap(Footer, 'app__footer'),
    'contact',
    'app__whitebg'
)